import { render, staticRenderFns } from "./TargetSituation.vue?vue&type=template&id=513c1982&scoped=true&lang=pug&"
import script from "./TargetSituation.vue?vue&type=script&lang=ts&"
export * from "./TargetSituation.vue?vue&type=script&lang=ts&"
import style0 from "./TargetSituation.vue?vue&type=style&index=0&id=513c1982&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c1982",
  null
  
)

export default component.exports